import { WELLNESS_METRICS as SHARED_WELLNESS_METRICS, type WellnessMetric } from "@consistency-circle/shared";
import { BedIcon, DumbbellIcon, UtensilsIcon, type LucideIcon } from "lucide-react";

const ICONS: Record<WellnessMetric["key"], LucideIcon> = {
  sleepHours: BedIcon,
  sleepQuality: BedIcon,
  dietQuality: UtensilsIcon,
  exerciseQuality: DumbbellIcon,
};

export const WELLNESS_METRICS = SHARED_WELLNESS_METRICS.map((metric) => ({
  ...metric,
  Icon: ICONS[metric.key],
}));

export type WebWellnessMetric = (typeof WELLNESS_METRICS)[number];
